import { format } from 'date-fns'
import {
  AppointmentLogsListData,
  GetAppointmentListMapper,
} from '../../../TelemedicineServices.types'
import { autoCapitalize } from '@/utils/autoCapitalize'
import { replaceValueNotExist } from '@/utils/replaceValueNotExisting'

class AppointmentLogsListMapper {
  toDomain(persistenceData: AppointmentLogsListData) {
    return {
      appointmentId: replaceValueNotExist(persistenceData?.idAtendimento),
      id: persistenceData?.id,
      professionalId: persistenceData?.idProfissional,
      patientId: persistenceData?.idPaciente,
      patientName: autoCapitalize(persistenceData?.nomePaciente),
      clinicId: persistenceData?.idClinica,
      clinicName: autoCapitalize(persistenceData?.nomeClinica),
      specialtyId: persistenceData?.idEspecialidade,
      specialtyName: persistenceData?.nomeEspecialidade,
      professionalType: {
        id: persistenceData?.tipoProfissional?.id,
        description: persistenceData?.tipoProfissional?.descricao,
        councilType: persistenceData?.tipoProfissional?.tipoConselho,
      },
      initialDate: persistenceData?.dataEntrada,
      inclusionBackofficeUser: replaceValueNotExist(
        autoCapitalize(persistenceData?.nomeUsuarioInclusao),
      ),
      appointmentDate: persistenceData?.dataAgendamento,
    }
  }

  toPersistence(domainData: GetAppointmentListMapper) {
    const initialDateFormatted = format(
      new Date(domainData?.initialDate),
      'dd/MM/yyyy HH:mm:ss',
    )

    const finalDateFormatted = format(
      new Date(domainData?.finalDate),
      'dd/MM/yyyy HH:mm:ss',
    )

    const patientNameValidate = domainData?.patientName
      ? domainData?.patientName
      : null

    return {
      dataInicio: initialDateFormatted,
      dataFim: finalDateFormatted,
      nomePaciente: patientNameValidate,
    }
  }
}

export default new AppointmentLogsListMapper()
